import React from 'react';
import { motion } from 'framer-motion';
interface TopographicPatternProps {
  color?: 'olive' | 'sage' | 'slate';
  opacity?: number;
  animate?: boolean;
}
export function TopographicPattern({
  color = 'olive',
  opacity = 0.03,
  animate = true
}: TopographicPatternProps) {
  const colors = {
    olive: '#6B7456',
    sage: '#A4B494',
    slate: '#4A6B7C'
  };
  const strokeColor = colors[color];
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-168">
      <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg" data-id="element-169">
        <defs data-id="element-170">
          <pattern id={`topo-${color}`} x="0" y="0" width="800" height="600" patternUnits="userSpaceOnUse" data-id="element-171">
            {/* Realistic contour lines - irregular, organic shapes like real topographic maps */}

            {/* Hill 1 - top left */}
            <path d="M 50,80 Q 80,75 110,80 Q 140,85 170,80 Q 200,75 220,90 Q 210,110 180,115 Q 150,120 120,115 Q 90,110 70,100 Q 50,90 50,80 Z" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.9} data-id="element-172" />
            <path d="M 70,90 Q 95,86 120,90 Q 145,94 170,90 Q 190,86 200,100 Q 190,112 165,115 Q 140,118 115,115 Q 90,112 75,105 Q 70,98 70,90 Z" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.75} data-id="element-173" />
            <path d="M 90,100 Q 110,97 130,100 Q 150,103 165,100 Q 175,97 180,108 Q 172,116 155,118 Q 138,120 120,118 Q 102,116 95,110 Q 90,105 90,100 Z" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.6} data-id="element-174" />

            {/* Hill 2 - center */}
            <path d="M 280,150 Q 320,140 360,150 Q 400,160 440,155 Q 480,150 510,170 Q 500,200 460,210 Q 420,220 380,215 Q 340,210 310,195 Q 280,180 280,150 Z" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.85} data-id="element-175" />
            <path d="M 310,165 Q 345,157 380,165 Q 415,173 445,168 Q 470,163 485,180 Q 477,200 445,208 Q 413,216 380,211 Q 347,206 325,193 Q 310,183 310,165 Z" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.7} data-id="element-176" />
            <path d="M 340,180 Q 370,174 400,180 Q 430,186 455,182 Q 470,178 475,190 Q 468,200 440,205 Q 412,210 385,207 Q 358,204 348,195 Q 340,188 340,180 Z" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.55} data-id="element-177" />

            {/* Hill 3 - bottom right */}
            <path d="M 550,320 Q 590,310 630,320 Q 670,330 700,325 Q 730,320 750,345 Q 740,375 700,385 Q 660,395 620,390 Q 580,385 560,365 Q 550,350 550,320 Z" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.8} data-id="element-178" />
            <path d="M 575,335 Q 610,327 645,335 Q 680,343 705,338 Q 725,333 735,352 Q 727,372 690,380 Q 653,388 620,383 Q 587,378 577,360 Q 575,348 575,335 Z" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.65} data-id="element-179" />

            {/* Valley lines - flowing between hills */}
            <path d="M 230,120 Q 260,180 280,240 Q 295,280 310,320" stroke={strokeColor} strokeWidth="1" fill="none" opacity={opacity * 0.5} strokeDasharray="3,3" data-id="element-180" />
            <path d="M 180,140 Q 200,200 210,260 Q 220,300 230,340" stroke={strokeColor} strokeWidth="1" fill="none" opacity={opacity * 0.4} strokeDasharray="3,3" data-id="element-181" />

            {/* Additional scattered contour lines for texture */}
            <path d="M 100,250 Q 140,245 180,250 Q 220,255 250,250" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.5} data-id="element-182" />
            <path d="M 120,280 Q 155,276 190,280 Q 225,284 255,280" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.45} data-id="element-183" />

            <path d="M 450,420 Q 490,415 530,420 Q 570,425 600,420" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.55} data-id="element-184" />
            <path d="M 470,450 Q 505,446 540,450 Q 575,454 605,450" stroke={strokeColor} strokeWidth="1.5" fill="none" opacity={opacity * 0.5} data-id="element-185" />
          </pattern>
        </defs>

        <rect width="100%" height="100%" fill={`url(#topo-${color})`} data-id="element-186" />
      </svg>
    </div>;
}